import { useState } from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import I18n from 'i18n-js';

// @ts-ignore lib
import { LANGUAGES } from '@lootboy/translations/config';

import AnimatedCheckIcon from '~/components/atoms/AnimatedCheckIcon';
import { ListContainer } from '~/components/atoms/ListContainer';
import StyledButton, {
  EStyledButtonVariant,
} from '~/components/atoms/StyledButton';
import ButtonClean from '~/components/ButtonClean';
import BottomSheetDialog from '~/components/molecules/BottomSheetDialog';

import { setLanguage } from '~/redux/actions/LanguageActions';
import { languageSelector } from '~/redux/selectors';
import { useAppDispatch } from '~/redux/store/useAppDispatch';

import styles from './LanguageSelectDialog.module.scss';

type TLanguageSelectDialogProps = {
  onClose: () => void;
};

export function LanguageSelectDialog({
  onClose,
}: TLanguageSelectDialogProps): JSX.Element {
  const dispatch = useAppDispatch();
  const language = useSelector(languageSelector);
  const [selectedLanguage, setSelectedLanguage] = useState<string>(language);

  return (
    <BottomSheetDialog
      onClose={onClose}
      header={I18n.t('choose_language')}
      renderFooter={({ closeDialog }) => (
        <StyledButton
          variant={EStyledButtonVariant.BLUE}
          className={styles.footerButton}
          onClick={() => {
            if (selectedLanguage !== language) {
              dispatch(setLanguage(selectedLanguage));
            }
            closeDialog();
          }}
        >
          {I18n.t('confirm')}
        </StyledButton>
      )}
    >
      <ListContainer className={styles.list}>
        {(LANGUAGES as Array<string>).map((langCode) => (
          <li
            key={langCode}
            className={styles.languageElement}
          >
            <ButtonClean
              className={classNames(
                styles.language,
                selectedLanguage === langCode && styles.selected,
              )}
              onClick={() => setSelectedLanguage(langCode)}
            >
              {I18n.t(`language_${langCode}`)}
            </ButtonClean>
            {selectedLanguage === langCode && <AnimatedCheckIcon checked />}
          </li>
        ))}
      </ListContainer>
    </BottomSheetDialog>
  );
}
